import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { BarChart3 } from "lucide-react";

export default function AdminAnalyticsPage() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/overview").then((r) => setData(r.data)); }, []);

  if (!data) return <div className="kb-mono text-xs text-kb-ink-muted">Loading…</div>;

  return (
    <div data-testid="admin-analytics-page">
      <div className="kb-mono text-[10px] uppercase tracking-[0.2em] text-kb-ink-muted">PLATFORM ANALYTICS</div>
      <h1 className="font-serif text-3xl lg:text-4xl text-kb-ink mt-1">Health & <em className="italic text-kb-primary">KPIs</em></h1>

      <div className="mt-8 grid lg:grid-cols-3 gap-px bg-slate-200 border border-slate-200 rounded-sm overflow-hidden">
        {[
          { l: "Researchers", v: data.users_total },
          { l: "Active Projects", v: data.ideas_total },
          { l: "Published", v: data.papers_total },
          { l: "Mentors", v: data.mentors_total },
          { l: "Journals indexed", v: data.journals_total },
          { l: "Courses live", v: data.courses_total },
        ].map((s, i) => (
          <div key={i} className="bg-white p-6">
            <div className="flex items-center justify-between">
              <BarChart3 className="w-4 h-4 text-kb-primary" strokeWidth={1.5} />
              <span className="kb-mono text-[10px] uppercase tracking-[0.2em] text-kb-ink-light">KPI</span>
            </div>
            <div className="font-mono text-4xl text-kb-primary mt-4">{s.v}</div>
            <div className="kb-mono text-[10px] uppercase tracking-wider text-kb-ink-muted mt-1">{s.l}</div>
          </div>
        ))}
      </div>

      <div className="mt-10 kb-card p-7">
        <div className="kb-mono text-[10px] uppercase tracking-[0.2em] text-kb-ink-muted">USERS BY ROLE</div>
        <ul className="mt-4 space-y-2.5">
          {Object.entries(data.users_by_role).map(([r, n]) => (
            <li key={r} className="flex items-center gap-3 text-sm">
              <span className="text-kb-ink capitalize w-44">{r.replace(/_/g, " ")}</span>
              <div className="flex-1 h-1.5 bg-slate-100 rounded-full overflow-hidden">
                <div className="h-full bg-kb-primary" style={{ width: `${Math.min(100, n * 10)}%` }} />
              </div>
              <span className="kb-mono text-xs text-kb-ink-muted w-8 text-right">{n}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
